module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"root":"jQuery","commonjs":"jquery","commonjs2":"jquery","amd":"jquery"}
// module id = 1
// module chunks = 0